import { jsx as _jsx } from "react/jsx-runtime";
import { App, Result } from "antd";
import { useCallback } from "react";
import { providedModal } from "../others/providedModal.js";
import { __ } from "../utils/i18n.js";
function useRealCommerceErrorHandling() {
    const { message: antdMessage, modal } = App.useApp();
    // TODO: use generic support URL from shortcode parameter
    return useCallback((error, { alwaysModal, subTitle, closable, onBackendDown } = {
        alwaysModal: false
    })=>{
        const { isBackendDown, errors, message, status } = error;
        if (isBackendDown || status === 500) {
            if (onBackendDown) {
                onBackendDown(error);
                return;
            }
            providedModal("error", /*#__PURE__*/ _jsx(Result, {
                title: message,
                subTitle: subTitle,
                status: "500",
                style: {
                    paddingBottom: 15
                }
            }), modal, {
                onOk: ()=>window.location.href = __("https://devowl.io/support/"),
                okText: __("Contact support"),
                closable
            });
        } else if (alwaysModal) {
            providedModal("error", /*#__PURE__*/ _jsx(Result, {
                title: message,
                subTitle: subTitle,
                status: "403",
                style: {
                    paddingBottom: 15
                }
            }), modal, {
                closable
            });
        } else {
            Array.from(errors).forEach(({ message: msg })=>{
                antdMessage.error(msg, 6);
            });
        }
    }, []);
}
export { useRealCommerceErrorHandling };
